import { bookingInquiryApis } from '@apis/dashboard/bookingInquiryApis';
import { useMutation } from '@hooks/useMutation';
import { useQueryClient } from '@tanstack/react-query';
import { FormError } from '@utils/errors';

export const usePostBookingInquirySalespersonCustoms = (d2d_no: string) => {
  const queryClient = useQueryClient();

  return useMutation(
    async () => {
      const response = await bookingInquiryApis.post(
        '/dashboard/booking-inquiry/{d2d_no}/salesperson-customs/',
        {
          path: { d2d_no },
        },
      );
      if (response[400]) {
        throw new FormError('PostBookingInquiryStaff', response[400]);
      }
      return response[200]!;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([`/dashboard/booking-inquiry/${d2d_no}/`]);
        queryClient.invalidateQueries([
          `/dashboard/booking-inquiry/${d2d_no}/salesperson-customs/`,
        ]);
        queryClient.invalidateQueries([`/dashboard/booking-inquiry/`]);
      },
    },
  );
};
